"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var lodash_1 = __importDefault(require("lodash"));

function create(_ref) {
  var row_title = _ref.row_title,
      column_title = _ref.column_title;
  return {
    row_title: row_title,
    column_title: column_title
  };
}

exports.create = create;

function deDuplicate(groups) {
  return lodash_1.default.uniqWith(groups, lodash_1.default.isEqual);
}

exports.deDuplicate = deDuplicate;

function reject(target, excluded) {
  return lodash_1.default.reject(target, function (item) {
    return !!lodash_1.default.find(excluded, item);
  });
}

exports.reject = reject;